import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

export default function MissingInfoDialog({ open, onClose, missingFields }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Box component={Typography} variant='h3'>
                            <Box component='span'>Required Fields Missing</Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Typography variant="body2">
                            Please complete the following required fields before saving:
                        </Typography>
                        <ul>
                            {missingFields.map(f => (
                                <li key={f.key}>{f.label}</li>
                            ))}
                        </ul>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='flex-end' p={2}>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={onClose}
                            >
                                Close
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}